import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/kpi/report";

export default {
    /** 查询员工月度绩效报表 */
    report: (data) => axios.get({url: `${PREFIX_URI}/report`, data: data}),
    /** 查询某月目标明细（可按员工过滤） */
    goalRows: (employeeId, month) => axios.get({url: `${PREFIX_URI}/goalRows`, data: {employeeId, month}}),
};
